import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function getCSEventCodeList(data) {
	let response = await getAPIResponse("/v1/cs/event-code-list", data);
	if (response === null) {
		return null;
	}
	return response;
}